/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner } from "./ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner";
import {
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerFromJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerFromJSONTyped,
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerToJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerToJSONTyped,
} from "./ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner";

/**
 *
 * @export
 * @interface ApiGmwGeojsonList200ResponseFeaturesInnerProperties
 */
export interface ApiGmwGeojsonList200ResponseFeaturesInnerProperties {
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  uuid?: string;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  broId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  linkedGmns?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  nitgCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  wellConstructionDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  nrOfMonitoringTubes?: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  qualityRegime?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  removed?: string | null;
  /**
   *
   * @type {Array<ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner>}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerProperties
   */
  tubes?: Array<ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner>;
}

/**
 * Check if a given object implements the ApiGmwGeojsonList200ResponseFeaturesInnerProperties interface.
 */
export function instanceOfApiGmwGeojsonList200ResponseFeaturesInnerProperties(
  value: object
): value is ApiGmwGeojsonList200ResponseFeaturesInnerProperties {
  return true;
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesFromJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInnerProperties {
  return ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesFromJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwGeojsonList200ResponseFeaturesInnerProperties {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    broId: json["bro_id"] == null ? undefined : json["bro_id"],
    linkedGmns: json["linked_gmns"] == null ? undefined : json["linked_gmns"],
    nitgCode:
      json["nitg_code"] === undefined
        ? undefined
        : json["nitg_code"] === null
        ? null
        : json["nitg_code"],
    wellConstructionDate:
      json["well_construction_date"] === undefined
        ? undefined
        : json["well_construction_date"] === null
        ? null
        : json["well_construction_date"],
    nrOfMonitoringTubes:
      json["nr_of_monitoring_tubes"] == null ? undefined : json["nr_of_monitoring_tubes"],
    qualityRegime:
      json["quality_regime"] === undefined
        ? undefined
        : json["quality_regime"] === null
        ? null
        : json["quality_regime"],
    removed:
      json["removed"] === undefined ? undefined : json["removed"] === null ? null : json["removed"],
    tubes:
      json["tubes"] == null
        ? undefined
        : (json["tubes"] as Array<any>).map(
            ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerFromJSON
          ),
  };
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesToJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInnerProperties {
  return ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesToJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesToJSONTyped(
  value?: ApiGmwGeojsonList200ResponseFeaturesInnerProperties | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    uuid: value["uuid"],
    bro_id: value["broId"],
    linked_gmns: value["linkedGmns"],
    nitg_code: value["nitgCode"],
    well_construction_date: value["wellConstructionDate"],
    nr_of_monitoring_tubes: value["nrOfMonitoringTubes"],
    quality_regime: value["qualityRegime"],
    removed: value["removed"],
    tubes:
      value["tubes"] == null
        ? undefined
        : (value["tubes"] as Array<any>).map(
            ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerToJSON
          ),
  };
}
